// Wszystkie teksty przez klucze: interfejs po polsku, dokumenty wyjściowe po niemiecku (plan, sekcja 4.2).
const T = {
  pl: {
    'app.nazwa': 'Prowadzenie budowy',
    'start.tytul': 'Twoje budowy',
    'start.pusto': 'Nie masz jeszcze żadnej budowy. Załóż pierwszą, a potem wgraj jej plany.',
    'start.nowa': 'Nowa budowa',
    'start.ukryte': 'Pokaż ukryte budowy',
    'nowa.tytul': 'Nowa budowa',
    'nowa.nazwa': 'Nazwa budowy',
    'nowa.nazwa.pomoc': 'Krótka nazwa robocza, np. „Szkoła Lindenweg”. Bez adresu i nazwisk.',
    'nowa.kod': 'Kod (2–6 znaków)',
    'nowa.kod.pomoc': 'Pojawia się w nazwach dokumentów, np. LIN.',
    'nowa.umowa': 'Podstawa umowy',
    'nowa.land': 'Kraj związkowy (święta do terminów)',
    'nowa.zaloz': 'Załóż budowę',
    'nowa.anuluj': 'Anuluj',
    'bud.wstecz': 'Budowy',
    'stan.offline': 'Bez zasięgu: wszystko zapisuje się na tym urządzeniu.',
    'stan.niewyslane': 'Niewysłane zmiany: {n}',
    'stan.sync.blad': 'Synchronizacja: {p}',
    'stan.pliki': 'Pliki do wysłania: {n}',
    'stan.wyslij': 'Wyślij teraz',
    'stan.lokalnie': 'Dane tylko na tym urządzeniu (zmian: {n}). Kopia w chmurze w kolejnej wersji.',
    'stan.pamiec.nie': 'Przeglądarka może wyczyścić dane tej aplikacji. Dodaj ją do ekranu głównego, żeby dane były bezpieczniejsze.',
    'stan.pamiec.pelna': 'Miejsce na dane aplikacji zajęte w {p}% ({mb} MB). Zwolnij miejsce na telefonie, zanim zabraknie go na zdjęcia.',
    'blad.kod': 'Kod: 2–6 liter lub cyfr.',
    'blad.nazwa': 'Wpisz nazwę budowy.',
    'ok.zalozona': 'Budowa założona i zapisana na tym urządzeniu.',
    'bud.pusto': 'Ta budowa nie ma jeszcze pięter. Najpierw wgraj plany (niżej), potem z nich powstaną piętra i pomieszczenia.',
    'kon.przycisk': '✓ Kontrola wykonanych prac',
    'bud.rzuty': 'Rzuty pięter',
    'bud.demo': 'Wczytaj budowę demonstracyjną (do prób)',
    'bud.demo.laduje': 'Wczytuję budowę demonstracyjną…',
    'bud.demo.postep': 'Wczytaj budowę pokazową z postępem prac',
    'bud.demo.postep.ok': 'Budowa pokazowa wczytana: {n} punktów, {g} pomieszczeń gotowych, {p} pomiarów, usterki, zmiany i odbiór częściowy. Dane są wymyślone.',
    'bud.demo.ok': 'Budowa demonstracyjna wczytana: 2 piętra, 18 pomieszczeń, {n} punktów. Dane są wymyślone.',
    'dok.tytul': 'Plany i dokumenty',
    'dok.dodaj': 'Dodaj plany i dokumenty',
    'dok.anonim': 'Wgrywaj plany po anonimizacji (bramka na komputerze). Pliki zapisują się na tym urządzeniu.',
    'dok.pusto': 'Brak dokumentów. Dodaj rzuty pięter, legendę, schematy rozdzielnic i przedmiar.',
    'dok.stron': '{n} str.',
    'dok.rodzaj': 'Rodzaj dokumentu',
    'dok.dodano': 'Dodano dokumentów: {n}. Zapisane na tym urządzeniu.',
    'dok.juz': 'Te pliki są już w tej budowie.',
    'dok.blad': 'Nie udało się zapisać pliku na tym urządzeniu: {b}. Spróbuj jeszcze raz albo napisz do mnie.',
    'dok.laduje': 'Wczytuję plan…',
    'dok.brak': 'Nie znalazłem tego pliku na tym urządzeniu.',
    'dok.bezpodgladu': 'Ten rodzaj pliku nie ma jeszcze podglądu. Plik jest zapisany.',
    'rodzaj.rzut': 'Rzut piętra', 'rodzaj.legenda': 'Legenda', 'rodzaj.schemat': 'Schemat rozdzielnicy', 'rodzaj.lv': 'Przedmiar / LV', 'rodzaj.ppoz': 'Plan ppoż.', 'rodzaj.protokol': 'Protokół pomiarów', 'rodzaj.inne': 'Inne',
    'jak.tytul': 'Jak to działa?',
    'jak.start': 'Każda budowa to osobny projekt. Dane zapisują się najpierw na tym urządzeniu, także bez zasięgu, i wysyłają się same, gdy jest internet. Nic nie jest kasowane: ukryta budowa wraca jednym przyciskiem.',
  },
  de: {
    'app.nazwa': 'Baustellenführung',
    'start.tytul': 'Ihre Baustellen',
  },
};

let jezyk = 'pl';
export const ustawJezyk = (j) => { jezyk = T[j] ? j : 'pl'; };
export function t(k, vars = {}, lang = jezyk) {
  const s = T[lang]?.[k] ?? T.pl[k] ?? k;
  return s.replace(/\{(\w+)\}/g, (_, v) => vars[v] ?? '');
}
export const klucze = (lang) => Object.keys(T[lang] || {});
